const getSatelliteSize = compositeKey => {
  var imageSize = null;
  var customSizes = null;
  var key = null;
  if (compositeKey.geography === "HRPT") {
    imageSize = { width: 1024, height: 1024 };
    customSizes = {
      ELLESM: { width: 1850, height: 1560 },
      ARCCOM: { width: 1600, height: 1300 },
      RSB: { width: 1600, height: 1300 },
      HIGHARCTIC: { width: 800, height: 650 },
      BEAUFO: { width: 1850, height: 1560 }
    };
    key = compositeKey.subGeography;
  } else {
    imageSize = { width: 800, height: 800 };
    customSizes = {
      NA0: { width: 1280, height: 1024 },
      BC2: { width: 1400, height: 1024 },
      HUR: { width: 1170, height: 1080 }
    };
    key = compositeKey.geography;
  }

  var customSize = customSizes[key];
  return customSize ? customSize : imageSize;
};

const getGFASize = compositeKey => {
  const customSizes = {
    GFACN35: { width: 758, height: 592 },
    GFACN36: { width: 758, height: 592 }
  };

  // The default image size
  var imageSize = { width: 758, height: 608 };

  if (customSizes[compositeKey.geography]) {
    imageSize = customSizes[compositeKey.geography];
  }
  return imageSize;
};

const getSurfaceAnalysisSize = compositeKey => {
  var imageSize = { width: 2158, height: 1792 };

  const customSizes = {
    COMPLETE: { width: 2096, height: 1792 },
    ATLANTIC: { width: 1792, height: 1324 },
    PACIFIC: { width: 1200, height: 848 }
  };

  var customSize =
    customSizes[compositeKey.subProduct + compositeKey.geography];
  return customSize ? customSize : imageSize;
};

const getSigWXSize = compositeKey => {
  var imageSize = { width: 1103, height: 884 };

  const customSizes = {
    HIGH_LEVEL: {
      AMERICAS: { width: 1792, height: 2235 },
      ATLANTIC: { width: 2235, height: 1792 },
      SOUTH_PACIFIC: { width: 2235, height: 1792 },
      NORTH_PACIFIC: { width: 2235, height: 1792 }
    },

    MID_LEVEL: {
      ATLANTIC: { width: 1792, height: 866 },
      CANADA: { width: 1024, height: 749 }
    },

    SURFACE: {
      ATLANTICDEPICTION: { width: 1792, height: 1484 },
      PACIFICDEPICTION: { width: 1200, height: 848 }
    }
  };

  var customSize =
    customSizes[compositeKey.geography][
      compositeKey.subGeography + compositeKey.subProduct
    ];
  return customSize ? customSize : imageSize;
};

const getTurbulenceSize = compositeKey => {
  const customSizes = {
    NORTH_ATLANTIC: { width: 1240, height: 751 }
  };

  // The default image size
  var imageSize = { width: 1240, height: 999 };

  if (customSizes[compositeKey.geography]) {
    imageSize = customSizes[compositeKey.geography];
  }
  return imageSize;
};

const getModelSize = compositeKey => {
  const customSizes = {
    LO_LVL_THKNS: {
      COMBINED: { width: 1214, height: 1788 }
    }
  };

  if (
    customSizes[compositeKey.product] &&
    customSizes[compositeKey.product][compositeKey.subProduct]
  ) {
    return customSizes[compositeKey.product][compositeKey.subProduct];
  }

  // The default image size
  return { width: 2426, height: 1788 };
};

const getRadarSize = compositeKey => {
  const defaultRadarSize = { width: 572, height: 480 };

  const customSizes = {
    QUE: { width: 1024, height: 512 },
    ERN: { width: 768, height: 768 },
    NAT: { width: 1024, height: 512 },
    ONT: { width: 1024, height: 512 },
    WRN: { width: 1024, height: 512 },
    PAC: { width: 768, height: 512 }
  };

  if (customSizes[compositeKey.geography]) {
    return customSizes[compositeKey.geography];
  }

  return defaultRadarSize;
};

const dimensions = {
  GFA: getGFASize,
  LGF: compositeKey => ({ width: 756, height: 581 }),
  SATELLITE: getSatelliteSize,
  RADAR: getRadarSize,
  COMPOSITE_RADAR: getRadarSize,
  SURFACE_ANALYSIS: getSurfaceAnalysisSize,
  UPPER_ANALYSIS: compositeKey => ({ width: 2426, height: 1788 }),
  SIG_WX: getSigWXSize,
  TURBULENCE: getTurbulenceSize,
  "4_PANEL_CLOUD": getModelSize,
  LOLVL_MAXWND: getModelSize,
  ICG_TURBC: getModelSize,
  PCPN_THKNS_PRES: getModelSize,
  LO_LVL_THKNS: getModelSize,
  "4PAN": getModelSize,
  BOUNDARY_LAYER: getModelSize,
  LOW_LEVEL_WIND: compositeKey => ({ width: 799, height: 450 }),
  HIGH_LEVEL_WIND: compositeKey => ({ width: 1024, height: 689 })
};

const calculateRatio = compositeKey => {
  var size = dimensions[compositeKey.product](compositeKey);
  return size.width / size.height;
};
export default calculateRatio;
